import { List, Card, Show, MyPending, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/lrc-list",
        component: List,
        name: "lrc-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/lrc/new",
        component: Create,
        name: "lrc-new",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/lrc/:id/show",
        component: Show,
        name: "lrc-show",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/lrc/:id/edit",
        component: Edit,
        name: "lrc-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/lrc/:id/card",
        component: Card,
        name: "lrc-card",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/lrc-approval-pending",
        component: MyPending,
        name: "lrc-pending",
        meta: {
            requiresAuth: true,
        },
    },
];
